import Modules from './views/modules';
import React from 'react';
import './views/assets/styles/index.css';
import { useSetupWebVitalsAndTracing } from './utils/telemetry';

function App() {
  useSetupWebVitalsAndTracing();
  return (
    <Modules />
  );
}

export default App;
